import { apiEndpoints } from "../api-config";
import { requestJson } from "../http";

/** Submits an application. Throws ApiError if the API rejects it. */
export const applyJob = (slug: string, id: string, formData: FormData) =>
  requestJson(apiEndpoints(slug).application(id), {
    method: "POST",
    body: formData,
  });
